// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__2ZNfr","content":"LoadingAlert_content__2GDa6"};